"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    outgoingMessage: 'Utgående meddelande' || 'outgoingMessage',
    writeFtpFile: 'Skriv FTP fil' || 'writeFtpFile',
    resendEvent: 'Försök igen' || 'resendEvent',
    writeOutgoingIntegrationMessage: 'Skriv utgående meddelande' || 'writeOutgoingIntegrationMessage',
    writeOutgoingMessage: 'Skapa utgående meddelande' || 'writeOutgoingMessage',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    integration: 'Integration' || 'integration',
    fileName: 'Filnamn' || 'fileName',
    status: 'Status' || 'status',
    statuses: {
        error: 'Misslyckades' || 'error',
        resolved: 'Åtgärdat' || 'resolved',
        success: 'OK' || 'success',
    },
    outgoing: 'Kanal' || 'outgoing',
    errorMessage: 'Felmeddelande' || 'errorMessage',
    outgoingBodyS3Path: 'Utgående meddelande' || 'outgoingBodyS3Path',
    eventS3Path: 'Händelse' || 'eventS3Path',
    entityId: 'Identitet på entitet' || 'entityId',
    keywords: 'Sökord' || 'keywords',
};
